import {useState, useMemo} from "react";
import orderBy from "lodash/orderBy";
import {Box, Table} from "@chakra-ui/react";
import {FiArrowUp, FiArrowDown} from "@onemind-services-llc/react-icons-ng/fi";
import TableBody from "./TableBody";

const HEADERS = [
  {label: "NAME", value: "name"},
  {label: "CPU", value: "cpu"},
  {label: "RAM", value: "ram"},
  {label: "QUANTITY", value: "quantity"},
];

const StripedTable = (props) => {
  const {data} = props;
  const [sortConfig, setSortConfig] = useState({key: "", direction: "asc"});

  const sortedData = useMemo(() => {
    let newData = data;
    if (sortConfig.key) {
      newData = orderBy(data, [sortConfig.key], [sortConfig.direction]);
    }
    return newData;
  }, [data, sortConfig]);

  const handleHeaderClick = (newKey) => {
    let key = newKey;
    let direction = "asc";
    if (sortConfig.key === newKey && sortConfig.direction === "asc") {
      direction = "desc";
    } else if (sortConfig.key === newKey && sortConfig.direction === "desc") {
      key = "";
      direction = "";
    }
    setSortConfig({key, direction});
  };

  return (
    <>
      <Table.Root>
        <Table.Header>
          <Table.Row
            background={"#1A5F7A"}
            h={"60px"}
            position={"sticky"}
            zIndex={"5"}
            top={"0"}
          >
            {HEADERS.map((item, index) => {
              return (
                <Table.ColumnHeader
                  data-cy="table-header"
                  fontSize={"16px"}
                  color={"white"}
                  key={index}
                  cursor={"pointer"}
                  textAlign={"center"}
                  onClick={() => handleHeaderClick(item.value)}
                >
                  {item.label}
                  {sortConfig.key === item.value &&
                    (sortConfig.direction === "asc" ? <FiArrowUp /> : <FiArrowDown />)}
                </Table.ColumnHeader>
              );
            })}
          </Table.Row>
        </Table.Header>
        <TableBody tableBodyData={sortedData} />
      </Table.Root>
      {!data?.length && (
        <Box
          fontSize="20px"
          width="100%"
          minH="150px"
          display="flex"
          justifyContent="center"
          alignItems="center"
          data-cy="no-results-found"
        >
          No Results Found
        </Box>
      )}
    </>
  );
};

export default StripedTable;
